import { Themed } from "@components/atoms/Themed"
import { ScrollReveal } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Testimonial",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/testimonial", (props) => {
  const hasTheme = props.pageTheme && props.pageTheme !== "none"

  return (
    <Themed theme={props.pageTheme || "none"} className="w-grid mx-auto my-10 py-10">
      <ScrollReveal className="flex flex-col items-center justify-center gap-5 themed-bg themed-fg rounded-lg md:p-9">
        <EditableText
          as="p"
          store="testimonial"
          className={cn("type-title-m md:type-title-m text-balance text-center", hasTheme && "type-title-m")}
          placeholder="Enter a testimonial"
          data-transition="fade-up"
        />
        <EditableText
          as="p"
          store="author"
          className={cn("type-body-m md:type-title-s text-center", hasTheme && "type-body-xl")}
          placeholder="Enter an optional attribution"
          data-transition="fade-up"
        />
      </ScrollReveal>
    </Themed>
  )
})
